/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_HiddenInputs */

const cs_enum_hidden = /** @type {(inputs: Enum_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skrytá poloha`)
};

const en_enum_hidden = /** @type {(inputs: Enum_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Enum_HiddenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_hidden = /** @type {((inputs?: Enum_HiddenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_HiddenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_hidden(inputs)
	return cs_enum_hidden(inputs)
});